export const open_graph = {
  kr: {
    og_image: '//s3.marpple.co/files/u_4648126/2025/2/original/a7019f330ccdfb40d0dbf1c3b71935209495aafb1.png',
    og_url: 'https://marpple.shop/kr/@/commerce_creator',
    og_title: '브랜드와 함께 내 채널 수익 늘리기, 마플샵에서',
    og_description:
      '크리에이터를 가장 잘 아는 커머스, 마플샵에서 브랜드 매칭, 협상, 계약, cs 함께 해드려요. 커머스 크리에이터가 되어 브랜드와 함께 내 채널 수익을 늘려보세요!',
    meta_title: '브랜드와 함께 내 채널 수익 늘리기, 마플샵에서',
  },
  en: {
    og_image: '//s3.marpple.co/files/u_4648126/2025/2/original/a7019f330ccdfb40d0dbf1c3b71935209495aafb1.png',
    og_url: 'https://marpple.shop/kr/@/commerce_creator',
    og_title: '브랜드와 함께 내 채널 수익 늘리기, 마플샵에서',
    og_description:
      '크리에이터를 가장 잘 아는 커머스, 마플샵에서 브랜드 매칭, 협상, 계약, cs 함께 해드려요. 커머스 크리에이터가 되어 브랜드와 함께 내 채널 수익을 늘려보세요!',
    meta_title: '브랜드와 함께 내 채널 수익 늘리기, 마플샵에서',
  },
  jp: {
    og_image: '//s3.marpple.co/files/u_4648126/2025/2/original/a7019f330ccdfb40d0dbf1c3b71935209495aafb1.png',
    og_url: 'https://marpple.shop/kr/@/commerce_creator',
    og_title: '브랜드와 함께 내 채널 수익 늘리기, 마플샵에서',
    og_description:
      '크리에이터를 가장 잘 아는 커머스, 마플샵에서 브랜드 매칭, 협상, 계약, cs 함께 해드려요. 커머스 크리에이터가 되어 브랜드와 함께 내 채널 수익을 늘려보세요!',
    meta_title: '브랜드와 함께 내 채널 수익 늘리기, 마플샵에서',
  },
};
export const commerce_creator_apply_url = 'https://tally.so/r/mePZy0';
export const media_url_info = {
  ad_section: {
    image_1: '//s3.marpple.co/files/u_4648126/2025/2/original/943291d4bb09963c2191edb843193e039a8fe6aa1.png',
    image_2: '//s3.marpple.co/files/u_4648126/2025/2/original/6b55b1bcd93eb9bb907b3f7fb7ca4bb952a2a4991.png',
    video_1:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2025/2/original/ad_video_1.mp4',
    video_2:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2025/2/original/ad_video_2.mp4',
    video_3:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2025/2/original/ad_video_3.mp4',
  },
  benefit_section: {
    image_1: '//s3.marpple.co/files/u_4648126/2025/5/original/fe287f8ce7145ce9cfc44be18391a723a16a14ff1.png',
    image_2: '//s3.marpple.co/files/u_4648126/2025/2/original/cd73ea57458eade37daa5d2660c1b4dce35504ca3.png',
    image_3: '//s3.marpple.co/files/u_4648126/2025/5/original/65d7ccecb755f4cab023d7f750a35012b946ba2c1.png',
  },
  creator_section: {
    creator_top_image_urls: [
      '//s3.marpple.co/files/u_4648126/2025/2/original/24247e36cce21819dfc263625961aca3e4f35f131.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/8d51beaadd22685be88f168e325019a1ba8e0c8812.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/3db9aef80dafb6dae8767211c6070d0619b6057d11.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/fffa7c5389c2575dff65d7717b1600368f8e97fa10.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/fb86e11a0fc8678ed7f03b806325986e9f22c51b9.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/1cd461eaa2b9ca1e2297adb3e843fde47349e6f88.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/4a442c9981bdf0cb8101fb4dcdeb5a1374db35fc7.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/e450650f9779ff24d3f6a53cc7adbf3f3f63b2116.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/56decc9aba3ae633da689b3d0dd4981830c42bea5.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/165e84d2589d79cd88d98eb1195ca56cf1a3a50a4.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/c698823f8bed1d27d6178a8db212c7f99e8f7b613.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/7e4b4d679482972ba43f53ad01062507b18477612.png',
    ],
    creator_bottom_image_urls: [
      '//s3.marpple.co/files/u_4648126/2025/2/original/84f0e7434c0f00a1883785f65a56ec29ee218d311.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/1a92b312e701401bdbacca33d4cd4cfcec3c5e5912.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/0a6093255eb595995937c06a19af26d39b02169111.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/e6a2117cda2a5ac6784621be151683d72df6e7a210.png ',
      '//s3.marpple.co/files/u_4648126/2025/2/original/457c170a63f90611ce20c1dfd3694e5e207717e39.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/90998127097125162af42c46e02da68d5a58bf728.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/0f40c631a8322c2166f3eb23b61de57f9662683f7.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/acbc26c535452ea2c9591fd6322b230d342a45b56.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/6e30cb719fc95b13bf627bce35202df0e3af66db5.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/d1489401540f91dd3a5b3f34235fa4e85fbeb9194.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/3e7e34874089b6a53538585d5c58cc25935c58c83.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/8d4be74611849c80f492baa9b431f5183dafb8922.png',
    ],
    creator_image_urls_mo_top: [
      '//s3.marpple.co/files/u_4648126/2025/2/original/24247e36cce21819dfc263625961aca3e4f35f131.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/8d51beaadd22685be88f168e325019a1ba8e0c8812.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/fffa7c5389c2575dff65d7717b1600368f8e97fa10.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/fb86e11a0fc8678ed7f03b806325986e9f22c51b9.png',
    ],
    creator_image_urls_mo_mid: [
      '//s3.marpple.co/files/u_4648126/2025/2/original/1a92b312e701401bdbacca33d4cd4cfcec3c5e5912.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/e6a2117cda2a5ac6784621be151683d72df6e7a210.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/8d4be74611849c80f492baa9b431f5183dafb8922.png',
    ],
    creator_image_urls_mo_bottom: [
      '//s3.marpple.co/files/u_4648126/2025/2/original/e450650f9779ff24d3f6a53cc7adbf3f3f63b2116.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/56decc9aba3ae633da689b3d0dd4981830c42bea5.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/165e84d2589d79cd88d98eb1195ca56cf1a3a50a4.png',
      '//s3.marpple.co/files/u_4648126/2025/2/original/c698823f8bed1d27d6178a8db212c7f99e8f7b613.png',
    ],
  },
  recruit_section: {
    video:
      'https://s3.ap-northeast-2.amazonaws.com/s3.marpple.co/files/u_4648126/2025/2/original/commerce_myluv.mp4',
  },
};
